<template lang="pug">
menu-item(label="Jupyter Mode")
  menu-item(label="Screen shot", @click="screenshot")
  menu-item(label="Wait!", @click="wait", keybind="shift+w")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { JupyterModule, waitForImageLoad } from '.';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: JupyterModule

  screenshot() {
    // location.href = this.module.globe.canvas.domElement.toDataURL()
  }

  async wait() {
    const globe = this.module.getGlobe()
    await waitForImageLoad(globe)
    alert('done!')
  }
}
</script>